export default __webpack_public_path__ + "static/media/facil3.abcaeb19.png";